module.exports = __webpack_public_path__ + "img/hawk-and-man.e94abccc.svg";